<template>
    <div id="page-main">
      <section class="beerHeader">
      <h2>Our Beers</h2>
      <button v-on:click="addBeer()" v-show="brewerStatus===true" class="button">Add a beer</button>
      </section>
      <div v-for="beer in beers" v-bind:key="beer.beerId" class="beer">
        <article>
        <div class="beer-info">
          <h3 v-on:click="viewBeerDetail(beer.beerId)" v-bind:beer="beer" class="beer-link" >{{ beer.beerName }} ${{ beer.price }}</h3>
          <h4>{{ beer.style }}</h4>
          <h4>ABV: {{ beer.abv }}</h4>
          <h4>Average Rating: {{ this.$store.getters.getAverageRatingForBeerId(beer.beerId) }}<i 
                class="fa-solid fa-star"></i></h4>
          <p>{{ beer.description }}</p>
        </div>
        <div class="beer-image-container">
          <img v-bind:src="beer.imageUrl" v-if="beer.imageUrl !== null" v-on:click="viewBeerDetail(beer.beerId)" class="beer-image"/>
          <img src="../assets/mug.png" v-if="beer.imageUrl === null" v-on:click="viewBeerDetail(beer.beerId)" class="beer-image"/>
        </div>
      </article>
      <div class="brewer-btns" v-show="brewerStatus===true">
        <button v-on:click="deleteBeer(beer.beerId)" class="button">Delete Beer</button>
      </div>
      </div>
      
    </div>
  </template>
  
  <script>
  export default {
    name: "beer-list",
    methods:{
      viewBeerDetail(beerId) {
        this.$router.push(`/beer/${beerId}`)
      },
      addBeer() {
        this.$router.push(`/beerForm/${this.paramsId}`);
      },
      deleteBeer(beerId) {
        this.$store.commit("DELETE_BEER",beerId);
      }
    },
    data() {
      return {
        brewerStatus: this.$store.state.brewerStatus,
        paramsId: parseInt(this.$route.params.id),
      };
    },
    computed: {
        beers () {
            return this.$store.getters.getBeerForBrewery(this.paramsId)
        }
    }
  };
  </script>